import {isFeatureEnabled} from 'feature-flags';

import {featureFlags} from '@dms/feature-flags';

export function getVehicleAdvertisingBulkParams(actionKey: string, platforms: string[]) {
  if (actionKey !== 'SALES_ENABLE_VEHICLE_IN_ADVERTISEMENT') {
    return {platforms};
  }

  return {
    platforms,
    publishMobileDeViaAdvertisingBridge: isFeatureEnabled(
      featureFlags.ADVERTISEMENT_MOBILE_DE_PROMPT_BRIDGE
    ),
    publishVgpViaAdvertisingBridge: isFeatureEnabled(featureFlags.ADVERTISEMENT_VGP_PROMPT_BRIDGE),
    publishOtomotoViaAdvertisingBridge: isFeatureEnabled(
      featureFlags.ADVERTISEMENT_OTOMOTO_PROMPT_BRIDGE
    ),
    publishAutocarisViaAdvertisingBridge: isFeatureEnabled(
      featureFlags.ADVERTISEMENT_AUTOCARIS_PROMPT_BRIDGE
    ),
    publishHyundaiPromiseViaAdvertisingBridge: isFeatureEnabled(
      featureFlags.ADVERTISEMENT_HYUNDAI_PROMISE_PROMPT_BRIDGE
    ),
    publishMercedesNaSkladeViaAdvertisingBridge: isFeatureEnabled(
      featureFlags.ADVERTISEMENT_MERCEDES_NA_SKLADE_PROMPT_BRIDGE
    ),
  };
}
